import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderStudentFlatGroupDTO  {
    _originalTypeClassName = "ekylikeio.BO.OrderStudentFlatGroupDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderStudentFlatGroupDTO.translate = translateService;
}
this.Items = [];
this.TotalPrice = null;
this.Date = null;
this.DateSectionId = null;
this.StudentSectionId = null;
this.OrderId = null;
this.IsReady = false;
this.OrderStudentFlatGroupDTOKey = null;
this._key = this.OrderStudentFlatGroupDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
TotalPrice:any;
Date:any;
DateSectionId:any;
StudentSectionId:any;
OrderId:any;
IsReady:any;
SchoolBreak:any;
Student:any;
Items:any;
private _OrderStudentFlatGroupDTOKey:any;
get OrderStudentFlatGroupDTOKey(): any {
    return this._OrderStudentFlatGroupDTOKey;
  }
set OrderStudentFlatGroupDTOKey(value: any) {
    this._OrderStudentFlatGroupDTOKey = value;
    this._key = value;
  }
static setSchoolBreak = ($this, value) => {
var oldValue = $this.SchoolBreak;
$this.SchoolBreak = value;
if (value != null) {
}
}
static setStudent = ($this, value) => {
var oldValue = $this.Student;
$this.Student = value;
if (value != null) {
}
}
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.OrderStudentFlatGroupDTO.removeItems($this, $this.Items[0]);
                }

                Domain.OrderStudentFlatGroupDTO.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrderStudentFlatGroupDTO.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrderStudentFlatGroupDTO.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OrderStudentFlatGroupDTOKey == null || $this.OrderStudentFlatGroupDTOKey == 0;
            }


}